import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII, SHADOWS } from 'styles/consts'

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`

export const PopupContainer = styled.div`
  background: ${COLORS.surface};
  border-radius: ${RADII.popup};
  padding: 32px;
  max-width: 480px;
  width: 90%;
  box-shadow: ${SHADOWS.popup};
`

export const Title = styled.h2`
  margin: 0 0 16px 0;
  font-size: 24px;
  font-weight: 600;
  color: ${COLORS.textPrimary};
  text-align: center;
`

export const Message = styled.p`
  margin: 0 0 24px 0;
  font-size: 16px;
  line-height: 1.5;
  color: ${COLORS.textSecondary};
  text-align: center;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`

const BaseButton = styled.button`
  padding: 12px 24px;
  border-radius: ${RADII.field};
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
`

export const CancelButton = styled(BaseButton)`
  background: ${COLORS.fill};
  color: ${COLORS.textPrimary};

  &:hover {
    background: ${COLORS.fillStrong};
  }
`

export const ConfirmButton = styled(BaseButton)`
  background: ${COLORS.danger};
  color: ${COLORS.white};

  &:hover {
    filter: brightness(0.92);
  }
`
